const List = () => import('./main.vue');

export default [
  {
    name: 'processo/estorno-contas-contribuicao',
    path: '/processo/estorno-contas-contribuicao',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Estorno Contas Financeiro Contribuição',
      icon: 'funnel-dollar',
      can: 'list',
      on: 'procestornocontascontribuicao',
      bisneto: true,
    },
  },
];
